export async function reinitializeTheChangeValues (step, memoizedDispatch, changedFileds) {


    if(step === 0){

        let updatedStatus = {
            incSummDescription: false,
            preceEventsDescription: false,
            impact: false,
            detectionAndResponseDescription: false,
            mttd: false,
            mttrespond: false,
            mttrepair: false,
            mttrecover: false,
        }
       
        memoizedDispatch({
            type: "HANDLE EDITOR CHANGE",
            field: "changedFileds",
            payload: (prevChangedFileds) => ({
              ...prevChangedFileds, // Preserve all existing changedFileds values
              ...updatedStatus
            }),
          });
    }else if(step === 1){
        let updatedStatus = {
            rcidescription: false,
            rciquestions: false,
            recurrence: false,
            cause: false,
            recovery: false,
            rootCauseCode: false,
            rootCauseSubCode: false,
            subCategory: false,
            tags: false,
            incidentId: false,
            problemId: false,
            // CRITICAL: Do NOT reset vendor fields to false - they must persist!
            // causedByVendor: false,
            // vendorDetails: false,
            causedByChangeNumber: false,
            recurringIssue: false,
            impactedByChange: false,
        }

        memoizedDispatch({
            type: "HANDLE EDITOR CHANGE",
            field: "changedFileds",
            payload: (prevChangedFileds) => ({
              ...prevChangedFileds, // Preserve all existing changedFileds values
              ...updatedStatus
            }),
          });
    }else{
        let updatedStatus = {
            pTasks: false,
            jiraTickets: false,
        }
        memoizedDispatch({
            type: "HANDLE EDITOR CHANGE",
            field: "changedFileds",
            payload: (prevChangedFileds) => ({
              ...prevChangedFileds, // Preserve all existing changedFileds values
              ...updatedStatus
            }),
          });

    }

}